var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FEEBEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 17,
    fill: "#FBC1C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 33.3332C20.398 33.3332 16.667 29.6022 16.667 24.9998C16.667 20.3975 20.398 16.6665 25.0003 16.6665C29.6027 16.6665 33.3337 20.3975 33.3337 24.9998C33.3337 29.6022 29.6027 33.3332 25.0003 33.3332ZM24.167 27.4998V29.1665H25.8337V27.4998H24.167ZM24.167 20.8332V25.8332H25.8337V20.8332H24.167Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveModal);
export default __webpack_public_path__ + "static/media/remove-modal.4e89576432015454e72c9119938f450a.svg";
export { ForwardRef as ReactComponent };